import axios from 'axios'

const emailExistsInCognito = async (email) => {
  try {
    await axios.post('https://w2zgeuzzgg.execute-api.us-west-2.amazonaws.com/prod/check-email', { email })
    return true
  } catch (error) {
    return false
  }
}

export default emailExistsInCognito
